import React from 'react';
import { ROSTER_WEEKLY_CONFIG } from '../roster-weekly-config';
import { ThemeIcon, Text, UnstyledButton, Group } from '@good/ui/core';
import { ChevronDown, ChevronUp, Users } from '@good/icons';

const { GROUP_ROW_HEIGHT } = ROSTER_WEEKLY_CONFIG;

interface GroupColumnProps {
  setOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  text: string;
}

export function GroupColumn({ setOpen, isOpen, text }: GroupColumnProps) {
  return (
    <UnstyledButton w='100%' h={GROUP_ROW_HEIGHT} onClick={() => setOpen(!isOpen)} miw={200}>
      <Group wrap='nowrap' gap={4} justify='space-between'>
        <Group gap='xs'>
          <ThemeIcon variant='transparent' fz='sm' color='gray'>
            <Users />
          </ThemeIcon>
          <Text fw={550} size='sm'>
            {text}
          </Text>
        </Group>
        {isOpen ? (
          <ThemeIcon variant='transparent' fz='lg' color='gray'>
            <ChevronDown />
          </ThemeIcon>
        ) : (
          <ThemeIcon variant='transparent' fz='lg' color='gray'>
            <ChevronUp />
          </ThemeIcon>
        )}
      </Group>
    </UnstyledButton>
  );
}
